/* eslint-disable consistent-return */
/* eslint-disable no-undef */
/* eslint-disable array-callback-return */
import React from 'react';
import { advSearchState } from 'Stores/advSearch';
import { observer } from 'mobx-react';
import companySearchState from 'Stores/companySearch';
import * as CONSTANTS from 'Utils/constants';
import Utils from 'Utils/utils';
import { ReactComponent as CloseIcon } from '../../../assets/svg/close-material.svg';

export const RenderFilterList = observer(props => {
  const { data, currentSelectedState } = props;
  let index = 0;

  const removeFilter = (e, category, value) => {
    if (
      category !== undefined &&
      category !== '' &&
      value !== undefined &&
      value !== ''
    ) {
      Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_TAG_REMOVED, {});
      currentSelectedState.removeAppliedFilterFromGroup(category, value);
    }
  };

  const appliedKeys = Object.keys(data);
  const appliedFiltersView = [];
  appliedFiltersView.push(
    appliedKeys.map(item => {
      const keyItem = data[item];

      let isExcludeFilter = false;
      if (
        item === 'excludeIndustrySectorsV2' ||
        item === 'excludeCompanyKeywordV2' ||
        item === 'excludeTitle'
      )
        isExcludeFilter = true;

      if (
        item === 'industryName' ||
        item === 'industryKeywordsJson' ||
        item === 'industryKeywords' ||
        item === 'sectorKeywords' ||
        item === 'createdInLastNoOfDays'
      )
        return '';
      if (item === 'industrySectors') {
        if (
          !keyItem.isAllIndustry &&
          keyItem.industries &&
          keyItem.industries.length
        )
          // eslint-disable-next-line curly
          return keyItem.industries.map(value => {
            index += 1;
            // console.log('keyItem keyItem ', value);
            if (typeof value === 'object') {
              if (!value.sectors)
                return (
                  <div
                    key={`filter-item${index}`}
                    className="applied-filter-item"
                    data-category={item}
                    data-name={value.industry}
                    title={value.industry}
                    onClick={e => removeFilter(e, item, value.industry)}
                  >
                    <span>{value.industry}</span>
                    <CloseIcon className="svg-close-icon" />
                  </div>
                );
              if (value.sectors && value.sectors.length)
                return value.sectors.map((sectorValue, idx) => {
                  // eslint-disable-next-line no-unused-expressions
                  return (
                    <div
                      key={`filter-item${idx}`}
                      className="applied-filter-item"
                      data-category={item}
                      data-name={sectorValue}
                      title={value.industry}
                      onClick={e => removeFilter(e, item, sectorValue)}
                    >
                      <span>{sectorValue}</span>
                      <CloseIcon className="svg-close-icon" />
                    </div>
                  );
                });
            }
            if (value && !value.sectors)
              return (
                <div
                  key={`filter-item${index}`}
                  className="applied-filter-item "
                  data-category={item}
                  data-name={value.id !== undefined ? value.id : ''}
                  onClick={e => removeFilter(e, item, value.id)}
                >
                  <span>{value.name}</span>
                  <CloseIcon className="svg-close-icon" />
                </div>
              );
          });
        return '';
      }

      if (item === 'inclusionListIds' || item === 'exclusionListIds')
        return keyItem.map(value => {
          index += 1;
          const { listName, listId } = value;
          return (
            <div
              key={`filter-item${index}`}
              className="applied-filter-item no-action-allowed"
              data-category={item}
              data-name={listName !== undefined ? listName : ''}
            >
              <span>{listName}</span>
            </div>
          );
        });

      return keyItem.map(value => {
        index += 1;

        if (typeof value === 'string')
          return (
            <div
              key={`filter-item${index}`}
              className={`applied-filter-item${
                isExcludeFilter ? ' excluded-applied-filter-item' : ''
              }`}
              data-category={item}
              data-name={value}
              onClick={e => removeFilter(e, item, value)}
            >
              <span>{value}</span>
              <CloseIcon className="svg-close-icon" />
            </div>
          );

        return (
          <div
            key={`filter-item${index}`}
            className={`applied-filter-item${
              isExcludeFilter ? ' excluded-applied-filter-item' : ''
            }`}
            data-category={item}
            data-name={value.id !== undefined ? value.id : ''}
            onClick={e => removeFilter(e, item, value.id)}
          >
            <span>{value.name}</span>
            <CloseIcon className="svg-close-icon" />
          </div>
        );
      });
    }),
  );

  return appliedFiltersView;
});

const AppliedFilters = observer(props => {
  const [toggleBtn, setToggleBtn] = React.useState(false);
  const [showToggleBtn, setShowToggleBtn] = React.useState(false);

  const { currentTab = 'contact' } = props;

  let currentSelectedState;
  if (currentTab === 'contact') currentSelectedState = advSearchState;
  else currentSelectedState = companySearchState;

  const calcHeight = () => {
    const ele = document.getElementsByClassName('applied-filter-list');

    if (ele.length)
      if (ele[0].offsetHeight > 70) {
        setShowToggleBtn(true);
      } else {
        setShowToggleBtn(false);
      }

    console.log();
  };

  const toggleFilter = val => {
    if (!val)
      document
        .getElementsByClassName('applied-filter-list-wrapper')[0]
        .scrollTo(0, 0);

    const mxDataMap = {};
    if (val)
      Utils.mixpanelTrack(
        CONSTANTS.MX_AS_EVENTS.AS_FILTER_SHOW_MORE_CLICKED,
        mxDataMap,
      );
    else
      Utils.mixpanelTrack(
        CONSTANTS.MX_AS_EVENTS.AS_FILTER_SHOW_LESS_CLICKED,
        mxDataMap,
      );
    setToggleBtn(val);
  };

  React.useEffect(() => {
    calcHeight();
  });

  const mouseLeaveFn = event => {
    const { currentTarget } = event;
    const mxDataMap = {};

    if (currentTarget && currentTarget.classList.contains('allFilterShown')) {
      setToggleBtn(false);
      Utils.mixpanelTrack(
        CONSTANTS.MX_AS_EVENTS.AS_FILTER_SHOW_LESS_CLICKED,
        mxDataMap,
      );
    }
  };

  const clearAllFilter = () => {
    toggleFilter(false);
    currentSelectedState.clearAllFilters();
  };

  return (
    <>
      {Object.keys(currentSelectedState.appliedFilterSectionData).length > 0 ? (
        Object.keys(currentSelectedState.appliedFilterSectionData).length ===
          1 &&
        currentSelectedState.appliedFilterSectionData.industrySectors !==
          undefined &&
        !currentSelectedState.appliedFilterSectionData.industrySectors
          .isAllIndustry &&
        !currentSelectedState.appliedFilterSectionData.industrySectors
          .industries ? (
          ''
        ) : (
          <div
            className={
              toggleBtn === true
                ? 'allFilterShown applied-filters-section'
                : ' applied-filters-section'
            }
            onMouseLeave={e => mouseLeaveFn(e)}
          >
            <div className="parentCont">
              <div
                className={`applied-filter-list-wrapper ${
                  toggleBtn === false ? 'max-70' : 'max-all'
                }`}
              >
                <div className="applied-filter-list">
                  <RenderFilterList
                    currentSelectedState={currentSelectedState}
                    data={currentSelectedState.appliedFilterSectionData}
                  />
                </div>
                {toggleBtn === true && (
                  <div className="moreContainer inner">
                    <div
                      className="view-all-app-filters show-less"
                      onClick={() => toggleFilter(false)}
                    >
                      Show Less
                    </div>
                    <div className="show-more-wrap">
                      <div
                        className="view-all-app-filters clear-filter"
                        onClick={clearAllFilter}
                      >
                        Clear All
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {toggleBtn === false && (
                <div className="moreContainer">
                  {showToggleBtn &&
                    (toggleBtn === false ? (
                      <>
                        <div className="show-more-wrap">
                          <div
                            className="view-all-app-filters"
                            onClick={() => toggleFilter(true)}
                          >
                            Show More
                          </div>
                        </div>
                      </>
                    ) : (
                      <div
                        className="view-all-app-filters show-less"
                        onClick={() => toggleFilter(false)}
                      >
                        Show Less
                      </div>
                    ))}
                  <div className="show-more-wrap">
                    <div
                      className="view-all-app-filters clear-filter"
                      onClick={clearAllFilter}
                    >
                      Clear All
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )
      ) : (
        ''
      )}
    </>
  );
});

export { AppliedFilters };
export default AppliedFilters;
